import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import * as jaCommon from './local/ja/common';
import * as enCommon from './local/en/common';

// named exportをそのままネスト構造で登録（{ footer: {...}, nav: {...} } の形を保持）
const buildTranslation = (modules: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  Object.keys(modules).forEach((key) => {
    if (key !== 'default' && typeof modules[key] === 'object' && modules[key] !== null) {
      result[key] = modules[key];
    }
  });
  return result;
};

const resources = {
  ja: { translation: buildTranslation(jaCommon as Record<string, unknown>) },
  en: { translation: buildTranslation(enCommon as Record<string, unknown>) },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ja',
    debug: false,
    resources,
    returnObjects: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'ns_group_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
